@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

.delete-cell {
	background-color: white;
	display: flex;
  	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%; 
	box-sizing: border-box;
	
	
	& > [class^="icon-delete"] {
		color: Colors.$col-canceledRed;
		font-size: Constants.$val-fontSizeBig;
		cursor: pointer;

		&:hover {
			color: Colors.$color-red;
		}
	}
}

.archived {
	color: Colors.$col-design-grey400 !important;
	background-color: Colors.$col-greyBackgorund2 !important;
	width: 100%;
	height: 100%;
}

.nonArchived {
	height: 100%;
}
